"use strict";
/**
 * Created by rouven on 19.07.17.
 */
exports.__esModule = true;
var formErrorsActions_1 = require("./formErrorsActions");
var wikom_data_1 = require("@wikom/wikom-data");
var timeout = null;
var runningCheck = {};
var handleChange = function (_a) {
    var name = _a.name, url = _a.url;
    return function (values, dispatch) {
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(function () {
            if (runningCheck[name]) {
                runningCheck[name].cancel();
            }
            var req = wikom_data_1.actions.post({ url: url, data: values });
            runningCheck[name] = req
                .then(function (result) {
                dispatch((0, formErrorsActions_1.setFormErrors)(name, result.body.data));
                delete runningCheck[name];
            })["catch"](function (err) {
                if (err.code === 'ABORTED') {
                    return;
                }
                throw err;
            });
            runningCheck[name].cancel = function () { return req.abort(); };
            return runningCheck[name];
        }, 1000);
        return Promise.resolve('field changed');
    };
};
exports["default"] = handleChange;
